export const GET_IKU_REQUEST = "GET_IKU_REQUEST";
export const GET_IKU_SUCCESS = "GET_IKU_SUCCESS";
export const GET_IKU_FAILURE = "GET_IKU_FAILURE";
export const UPDATE_IKU_REQUEST = "UPDATE_IKU_REQUEST";
export const UPDATE_IKU_SUCCESS = "UPDATE_IKU_SUCCESS";
export const UPDATE_IKU_FAILURE = "UPDATE_IKU_FAILURE";
export const GET_IKU_ACCUMULATION_REQUEST = "GET_IKU_ACCUMULATION_REQUEST";
export const GET_IKU_ACCUMULATION_SUCCESS = "GET_IKU_ACCUMULATION_SUCCESS";
export const GET_IKU_ACCUMULATION_FAILURE = "GET_IKU_ACCUMULATION_FAILURE";
